import React, { Component } from 'react';

import { Modal } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import ScheduledEvents from './ScheduledEvents';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

export default class DisplayRowDate extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleLocalChange = this.handleLocalChange.bind(this);
  }

  handleLocalChange(field, date) {
    console.log(date);
    const d = new Date(date);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    return {
      target: {
        name: field,
        value: d,
      },
    };
  }

  render() {
    return (
      <tr>
        <td>
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            ''
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.value && this.props.value.substring(0, 10)}
        </td>
        {this.props.edit && (
          <Modal show={this.props.edit}>
            <Modal.Header>
              <Modal.Title>{this.props.prettyName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DatePicker
                onChange={(value) => {
                  this.props.handleChange(
                    this.handleLocalChange(this.props.id, value),
                  );
                }}
                value={
                  this.props.value &&
                  new Date(`${this.props.value.substring(0, 10)}T00:00:00`)
                }
              />
              <font className="mandatory">{this.props.errorString}</font>
              <ScheduledEvents
                events={this.props.events}
                id={this.props.id}
                deleteScheduleAction={this.props.deleteScheduleAction}
              />
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                onClick={this.props.handleClose}
                type="button"
                className="btn modalButtons btn-primary"
              >
                Close
              </button>
              <button
                onClick={this.props.handleSave}
                type="button"
                className="btn modalButtons btn-success"
              >
                Save
              </button>
              <button
                onClick={this.props.handleSchedule}
                type="button"
                className="btn modalButtons btn-success"
              >
                Schedule
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </tr>
    );
  }
}
